export class ApiEndpoint {
    id: string;
    isAllowed: boolean;

    constructor(id: string, isAllowed: boolean) {
        this.id = id;
        this.isAllowed = isAllowed;
    }
}

export default ApiEndpoint;



// WEBPACK FOOTER //
// ./src/models/ApiEndpoint.tsx